module.exports = __webpack_public_path__ + "img/menubutton_b.9b0368ca.svg";